export default __webpack_public_path__ + "static/media/avatar.79392581.png";